import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=09c06d53&"
import script from "./NotFound.ts?vue&type=script&lang=ts&"
export * from "./NotFound.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports